import { createPlatePlugin } from 'platejs/react';
import { ImageElement } from '../ImageElement/ImageElement';

// Custom void element plugin for inline images. We don't install
// @platejs/media — this is the bare minimum the one-pager needs:
// a `{ type: 'image', url, children: [{ text: '' }] }` block that
// renders <img> and round-trips through the Slate ↔ Plate
// serializers. URL lifecycle (base64 → docId → presigned URL) is
// handled by the existing imageUploadService.
export const ImagePlugin = createPlatePlugin({
    key: 'image',
    node: {
        isElement: true,
        isVoid: true,
        type: 'image',
    },
}).withComponent(ImageElement);
